module.exports = __webpack_public_path__ + "img/pictoPeople3.cd3b9cbc.svg";